import React, { useState, useEffect } from "react";
import { Link } from "gatsby";
import InView from "react-intersection-observer";
import HeaderAnim from "../utils/animations/textRevealAnimation";
import Parallax from "../utils/animations/parallax";
import { directions } from "../utils/animations/animationConstants";

export default function ColumnLayoutLanding(props) {
  const { header, subHeader, services, classes } = props.data;
  const [isVisible, setIsVisible] = useState(false);

  //const triggers = [0.80, 0.70, 0.60, 0.50, 0.40, 0.30, 0.20];
  const triggers = [[1, 0.85], [0.9, 0.75], [1, 0.85], [0.9, 0.75],];


  let servicesGrid = services.map((service, i) => {
    return <Parallax key={i} classes="col two-column-item" id={"two-column-item" + i} length={50} opacity={true} direction={directions.LTR} triggers={triggers[i]}>
      <div className="item-inner">
        <div className="item-icon">
          <i>{service.icon}</i>
        </div>
        <div className="item-content">
          <h3 className="h5">{service.header}</h3>
          <p>{service.content}</p>
        </div>
      </div>
    </Parallax>;
    //return <SlideInWithScroll elementTop={elementTop} clientHeight={clientHeight} children={jsx} triggerPoints={triggers[i]} key={i} />;
  });

  return (
    <div className="section-gap" id={props.id}>
      <InView onChange={(inView) => { setIsVisible(inView); }}>
        <div className={`section-title text-center ${classes}`}>
          <div className="container">
            {header && <p className="theme-color-title">{isVisible && <HeaderAnim header={header} />}</p>}
            {subHeader && <h2 className="h3">{subHeader}</h2>}
          </div>
        </div>
      </InView>
      <div className={`two-column-layout-section ${classes}`}>
        <div className="container">
          <div className="row d-flex flex-wrap justify-center">
            {services && servicesGrid}
          </div>
          <div className="text-center">
            <Link className="button button-black right-arrow" to="/services/digital-transformation/">Learn More</Link>
          </div>
        </div>
      </div>
    </div>
  );
}